import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import posed, { PoseGroup } from 'react-pose';
import cx from 'classnames';
import useOutsideClick from '@rooks/use-outside-click';

import Icon from 'common/icon';

const Indicator = posed.span({
    open: { rotate: 0 },
    closed: { rotate: -90 },
});

const Dropdown = posed.div({
    enter: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -10 },
});

const SelectFundraiserDropdown = ({ fundraisers, selected, onChange }) => {
    const container = useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    useOutsideClick(container, () => setIsOpen(false));

    // Close dropdown when fundraiser is selected
    useEffect(() => {
        setIsOpen(false);
    }, [selected]);

    const fundraiser = fundraisers.find(x => x.username === selected);

    return (
        <div className="relative text-14 md:text-16" ref={container}>
            <button
                type="button"
                onClick={() => setIsOpen(prev => !prev)}
                className={cx(
                    'border border-gray-20 rounded-t-lg py-4 px-8 text-gray-80 font-black flex items-center justify-between w-full bg-gray-10 relative z-10 text-left',
                    { 'rounded-b-lg': !isOpen }
                )}
            >
                <span className="flex items-center">
                    <Icon icon="user-circle" type="regular" size="2x" className="mr-4" />
                    {selected ? fundraiser?.name ?? selected : 'Give credit to a team member?'}
                </span>

                <Indicator pose={isOpen ? 'open' : 'closed'}>
                    <Icon icon="caret-down" type="solid" size="lg" />
                </Indicator>
            </button>
            <PoseGroup withParent={false}>
                {isOpen && (
                    <Dropdown
                        key="options"
                        className="bg-white rounded-b-lg shadow-lg font-medium py-4 absolute pin-x pin-from-t z-0"
                    >
                        {fundraisers.map(({ name, username }) => (
                            <button
                                key={username}
                                type="button"
                                onClick={() => onChange(username)}
                                className={cx('block w-full text-left py-4 px-8', {
                                    'text-gray-80 hover:bg-gray-10': username !== selected,
                                    'text-blue-70 bg-blue-10': username === selected,
                                })}
                            >
                                {name}
                            </button>
                        ))}
                        <button
                            type="button"
                            onClick={() => onChange(null)}
                            className={cx('block w-full text-left py-4 px-8', {
                                'text-gray-80 hover:bg-gray-10': !!selected,
                                'text-blue-70 bg-blue-10': !selected,
                            })}
                        >
                            None
                        </button>
                    </Dropdown>
                )}
            </PoseGroup>
        </div>
    );
};

SelectFundraiserDropdown.propTypes = {
    fundraisers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    onChange: PropTypes.func.isRequired,
    selected: PropTypes.string,
};

SelectFundraiserDropdown.defaultProps = {
    selected: null,
};

export default SelectFundraiserDropdown;
